export default "__VITE_ASSET__596b4652__"